export default __webpack_public_path__ + "static/media/thumbnail_03.85de3e04.png";